import { createElement } from 'react';
import { Card } from '@alifd/next';
import './index.scss';
const OadpCardBulletHeader = function OadpCardBulletHeader({ title, ...otherProps }) {
    return (createElement(Card.BulletHeader, Object.assign({ title: title }, otherProps)));
};
export default OadpCardBulletHeader;
